module.exports = __webpack_public_path__ + "static/transparency_iati-adda94e4cdc3b0f68e4ac0a27608b13f.png";